export default class ScrollAnimation {
  constructor() {
    this.$elements = [...document.querySelectorAll('[data-animate]')]
    if(!this.$elements) return;
    this.init();
  }

  init() {
    this.$elements.forEach(el => {
      switch (el.dataset.animate) {
        case 'story-img':
          this.animateStory(el);
          break;
      }
    });
  }

  animateStory(el) {
    const circle = el.querySelector('[data-animate="story-circle"]');
    const ill = el.querySelector('[data-animate="story-ill"]');
    const animateStoryTl = gsap.timeline();
    gsap.set(circle, { autoAlpha: 0, scale: 0 })
    gsap.set(ill, { autoAlpha: 0 })
    ScrollTrigger.create({
      trigger: el,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        animateStoryTl
          .to(circle, {
            autoAlpha: 1,
            scale: 1,
            duration: 0.5,
            ease: 'power3',
          })
          .to(ill, {
            autoAlpha: 1,
            duration: 0.75,
            ease: 'power0'
          }, '<0.25')
      }
    });
  }
}
